import * as Redux from 'redux'
import { Project } from '../public/models/project'
import { ACTION_TYPE, ProjectAction } from '../actions/project'
import { RequestFailure } from '@owl-nest/api-client'
import { Status } from '@owl-nest/redux-wrapper'

export type State = {
  token?: string
  data: Project
  failure?: RequestFailure
  status: {
    load: Status
    update: Status
    computeExamples: Status
    submit: Status
  }
}

export function reducerMaker(project: Project): Redux.Reducer<State, ProjectAction> {
  const initialState: State = {
    data: project,
    status: {
      load: Status.PRISTINE,
      update: Status.PRISTINE,
      computeExamples: Status.PRISTINE,
      submit: Status.PRISTINE,
    },
  }

  return function (state = initialState, action: ProjectAction): State {
    switch (action.type) {
      case ACTION_TYPE.UPDATE_REQUEST: {
        return {
          ...state,
          status: {
            ...state.status,
            update: Status.PENDING,
          },
        }
      }
      case ACTION_TYPE.UPDATE_FAILURE: {
        return {
          ...state,
          failure: action.failure,
          status: {
            ...state.status,
            update: Status.FAILURE,
          },
        }
      }
      case ACTION_TYPE.UPDATE_SUCCESS: {
        return {
          ...state,
          failure: undefined,
          data: action.success,
          status: {
            ...state.status,
            update: Status.SUCCESS,
          },
        }
      }
      case ACTION_TYPE.COMPUTE_EXAMPLES_REQUEST: {
        return {
          ...state,
          status: {
            ...state.status,
            computeExamples: Status.PENDING,
          },
        }
      }
      case ACTION_TYPE.COMPUTE_EXAMPLES_FAILURE: {
        return {
          ...state,
          failure: action.failure,
          status: {
            ...state.status,
            computeExamples: Status.FAILURE,
          },
        }
      }
      case ACTION_TYPE.COMPUTE_EXAMPLES_SUCCESS: {
        return {
          ...state,
          failure: undefined,
          data: {
            ...state.data,
            // any is needed because examples is undefined given the extra_fields
            // defined
            examples: action.success as any,
          },
          status: {
            ...state.status,
            computeExamples: Status.SUCCESS,
          },
        }
      }
      case ACTION_TYPE.SUBMIT_REQUEST: {
        return {
          ...state,
          status: {
            ...state.status,
            submit: Status.PENDING,
          },
        }
      }
      case ACTION_TYPE.SUBMIT_FAILURE: {
        return {
          ...state,
          failure: action.failure,
          status: {
            ...state.status,
            submit: Status.FAILURE,
          },
        }
      }
      case ACTION_TYPE.SUBMIT_SUCCESS: {
        return {
          ...state,
          failure: undefined,
          data: action.success,
          status: {
            ...state.status,
            submit: Status.SUCCESS,
          },
        }
      }
      case ACTION_TYPE.LOAD_REQUEST: {
        return {
          ...state,
          status: {
            ...state.status,
            load: Status.PENDING,
          },
        }
      }
      case ACTION_TYPE.LOAD_FAILURE: {
        return {
          ...state,
          failure: action.failure,
          status: {
            ...state.status,
            load: Status.FAILURE,
          },
        }
      }
      case ACTION_TYPE.LOAD_SUCCESS: {
        return {
          ...state,
          data: action.success,
          status: {
            ...state.status,
            load: Status.SUCCESS,
          },
        }
      }
      default:
        return state
    }
  }
}
